// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fZRof","image":"styles_image__3ptO5","code":"styles_code__3YHFR","btn":"styles_btn__5QR5h"};